import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=7067555e&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=7067555e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067555e",
  null
  
)

export default component.exports